import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=b52bda58&scoped=true&"
import script from "./ActionButton.vue?vue&type=script&lang=js&"
export * from "./ActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52bda58",
  null
  
)

export default component.exports